if (!window.Eurus.loadedScript.has('article.js')) {
  window.Eurus.loadedScript.add('article.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {

      Alpine.data('xArticle', () => ({
        
        init() {
          const menuArticle = document.querySelector('.menu-article');
          if (!menuArticle) return;

          const headings = this.$refs.content.querySelectorAll('h2');

          if (headings.length <= 1) {
            menuArticle.remove();
            return;
          }

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const activeItem = document.querySelector('.menu-article .active');
                if (activeItem) activeItem.classList.remove("active");

                const items = document.querySelectorAll('.item-menu-article');
                if (items[entry.target.dataset.index]) {
                  items[entry.target.dataset.index].classList.add("active");
                }
              }
            });
          }, { rootMargin: '0px 0px -60% 0px' });

          headings.forEach((heading, index) => {
            heading.dataset.index = index;
            observer.observe(heading);
          });
        },

        loadData() {
          const load = document.querySelector('.load-curr');
          const loadBar = document.querySelector('.load-bar');
          const element = this.$refs.content;

          /* Scroll progress bar */
          document.addEventListener('scroll', () => {
            if (!load || !loadBar) return;

            const elementTop = element.offsetTop;
            const elementHeight = element.offsetHeight;
            const windowHeight = window.innerHeight;
            const scrollPosition = window.scrollY + windowHeight;

            let scrollPercent;

            if (scrollPosition < elementTop) {
              scrollPercent = 0;
              loadBar.classList.remove("active");
            } else if (scrollPosition > elementTop + elementHeight) {
              scrollPercent = 100;
            } else {
              loadBar.classList.add("active");
              scrollPercent = ((scrollPosition - elementTop) / elementHeight) * 100;
            }

            load.style.width = `${scrollPercent.toFixed(2)}%`;
          });

          /* Build TOC using ONLY H2 */
          const headings = this.$refs.content.querySelectorAll('h2');
          if (headings.length <= 1) return;

          let htmlContent = "";

          headings.forEach((item, index) => {
            htmlContent += `
              <li 
                class="toc:m-0 item-menu-article w-full cursor-pointer pb-2"
                @click="scrollTop($el, ${index})"
              >
                ${item.textContent}
              </li>
            `;
          });

          document.querySelector('.list-menu-article').innerHTML = htmlContent;
        },

        scrollTop(el, index) {
          const headings = this.$refs.content.querySelectorAll('h2');
          if (headings.length <= index) return;

          const activeItem = document.querySelector('.menu-article .active');
          if (activeItem) activeItem.classList.remove("active");

          el.classList.add("active");

          headings[index].scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }

      }));


      /* Sidebar Store (UNCHANGED) */
      Alpine.store('xSideBar', {
        setPositionSideBar() {
          let sideBar = document.getElementById('side-bar');
          let sideBarContent = document.getElementById('side-bar-template');

          if (sideBarContent) {
            sideBar.innerHTML = sideBarContent.innerHTML;
            let tableInfomation = document.querySelector('.menu-article');

            if (tableInfomation && sideBar.children[0].dataset.position == tableInfomation.dataset.position) {
              if (sideBar.children[0].dataset.sticky && !tableInfomation.dataset.sticky) {
                sideBar.classList.add("lg:sticky");
                tableInfomation.appendChild(sideBar);
              } else {
                tableInfomation.children[0].appendChild(sideBar);
              }

              sideBar.classList.add("lg:pt-5");
              sideBar.classList.remove("lg:w-1/3");
            } else {
              sideBar.classList.add("lg:w-1/3");

              if (sideBar.children[0].dataset.position == "right") {
                sideBar.classList.add("order-3");
              } else {
                sideBar.classList.add("order-1");
              }
            }

            sideBar.classList.remove("hidden");
          } else {
            sideBar.classList.add("hidden");
          }
        }
      });

    });
  });
}